import React, { useEffect, useState } from 'react';
import ReactHighcharts from 'react-highcharts';
import { useDispatch } from 'react-redux';
import actions from '../../../redux/actions';
import reportsLoader from '../../../public/icons/loader.png';


const MonthlyUniqueUsers = () => {

    const { dashboardActiveUserMonthly } = actions;
    const dispatch = useDispatch()
    const [resp, setResp] = useState()
    const [loading, setLoading] = useState()
    const [config, setConfig] = useState(null)

    const fetchData = async () => {
        setLoading(true)

        try {
            const response = await dispatch(dashboardActiveUserMonthly())
            setResp(response.data)
            setConfig({
                chart: {
                    type: 'areaspline'
                },
                title: {
                    text: ``
                },
                xAxis: {
                    categories: Object.keys(response.data?.graph_data)
                },
                yAxis: {

                    labels: {
                        formatter: function () {
                            return this.value + ' ';
                        }
                    }
                },
                tooltip: {
                    shared: true,
                    valueSuffix: ' Users'
                },
                plotOptions: {
                    areaspline: {
                        fillOpacity: 0.5
                    }
                },
                series: [
                    {
                        name: `Users`,
                        data: Object.keys(response.data?.graph_data).map((key) => response.data?.graph_data[key]),
                        color: '#978FED'
                    },

                ]
            })
        }
        catch (e) {

        }
        finally {
            setLoading(false)
        }


    }

    useEffect(() => {
        fetchData()
    }, [])
    return (
        <div style={{ width: '100%' }}>
            <h3 className='graphTitle'>Monthly Unique Users</h3>
            {
                config ? <ReactHighcharts config={config} /> : <div className="loader">
                    <img style={{ width: '60px' }} src={reportsLoader} />
                </div>
            }
        </div>
    )
}

export default MonthlyUniqueUsers